export enum LocalStorageKeyEnum {
  LoginRedirectUrl = 'loginRedirectUrl',
  GlobalSearchHistory = 'globalSearchHistory',
}
